export default class HttpErrorHandler {
  static apply(error: any): string[] {
    const handledError = this.getHttpDataError(error);
    return this.handleMessagesHttpDataError(handledError);
  }

  private static getHttpDataError(error: any): any {
    if (error.response) {
      return this.getHttpDataError(error.response);
    }

    if (error.data) {
      return this.getHttpDataError(error.data);
    }

    if (error.status && error.messages) {
      return error;
    }

    return {
      status: 500,
    };
  }

  private static handleMessagesHttpDataError(error: any): string[] {
    if (error.status && error.status.toString().startsWith('4') && error.messages) {
      return error.messages;
    }
    return ['Ocorreu erro inesperados em nossos servidores, tente novamente mais tarde!'];
  }
}
